// extracted by mini-css-extract-plugin
export default {"max-diff":"MaxDiff_max-diff__z5pGk"};